import { Grid, Typography, useTheme } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import CustomSvgIcon from '@/components/icons/builder/CustomSvgIcon'
import checkInCircleFilledIcon from '@/components/icons/builder/paths/checkInCircleFilledIcon'

const CtmCalculatorHints = ({ mode = null, product, amount = null, amountRenove = null }) => {
  const theme = useTheme()
  const { t } = useTranslation()
  return (
    <>
      <Grid size={12} style={{ display: 'flex', gap: '.5rem' }}>
        <CustomSvgIcon
          width="1rem"
          height="1rem"
          svgString={checkInCircleFilledIcon}
          fill={theme.palette.icon.data.color}
        />
        <Typography variant="body_xxs_medium" style={{ color: theme.palette.text.dark.color }}>
          {t('CALCULATOR.HINTS.1')}
        </Typography>
      </Grid>
      {mode && mode === 'NOFEE' && (
        <>
          <Grid size={12} style={{ display: 'flex', gap: '.5rem' }}>
            <CustomSvgIcon
              width="1rem"
              height="1rem"
              svgString={checkInCircleFilledIcon}
              fill={theme.palette.icon.data.color}
            />
            <Typography variant="body_xxs_medium" style={{ color: theme.palette.text.dark.color }}>
              {t('CALCULATOR.HINTS.OPENINGFEEMARKUP', {
                markup: (product?.merchantopeningfee ?? 0)?.toLocaleString('es-ES', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }),
              })}
            </Typography>
          </Grid>
        </>
      )}
      <Grid size={12} style={{ display: 'flex', gap: '.5rem' }}>
        <CustomSvgIcon
          width="1rem"
          height="1rem"
          svgString={checkInCircleFilledIcon}
          fill={theme.palette.icon.data.color}
        />
        <Typography variant="body_xxs_medium" style={{ color: theme.palette.text.dark.color }}>
          {t('CALCULATOR.HINTS.OPENINGFEE', {
            openingfee: (product?.openingFee ?? 0)?.toLocaleString('es-ES', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }),
          })}
        </Typography>
      </Grid>
      {mode && mode === 'RENOVE' && (
        <>
          <Grid size={12} style={{ display: 'flex', gap: '.5rem' }}>
            <CustomSvgIcon
              width="1rem"
              height="1rem"
              svgString={checkInCircleFilledIcon}
              fill={theme.palette.icon.data.color}
            />
            <Typography variant="body_xxs_medium" style={{ color: theme.palette.text.dark.color }}>
              {t('CALCULATOR.HINTS.RENOVE.ENTERPRISE', {
                amount: (amountRenove ?? 0)?.toLocaleString('es-ES', {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                }),
              })}
            </Typography>
          </Grid>
        </>
      )}
    </>
  )
}

export default CtmCalculatorHints
